import { CustomPaletteProvider } from './CustomPaletteProvider';

export const CustomPaletteModule = {
    __init__: ['customPaletteProvider'],
    customPaletteProvider: ['type', CustomPaletteProvider],
};
